import { Carousel } from 'react-bootstrap'
import IndicatorRenderer from '../IndicatorRenderer'
import './IndicatorCarousel.css'

const IndicatorCarousel = ({
  visibleIndicators,
  currentIndex,
  onSelect,
  group,
  currentCode,
  countryMap,
  compareMode,
  compareData,
  compareCountries,
  canDownload = true,
}) => {
  if (!visibleIndicators.length) {
    return (
      <div className="indicator-carousel-placeholder unavailable-slide">
        <h5>Unavailable</h5>
      </div>
    )
  }

  return (
    <Carousel
      interval={null}
      activeIndex={currentIndex}
      onSelect={onSelect}
    >
      {visibleIndicators.map((indicator, index) => (
        <Carousel.Item key={indicator.id}>
          <IndicatorRenderer
            indicator={indicator}
            activeIndex={currentIndex}
            myIndex={index}
            groupColor={group?.color}
            groupCode={group?.code}
            currentCode={currentCode}
            countryMap={countryMap}
            compareMode={compareMode}
            compareData={compareData}
            compareCountries={compareCountries}
            canDownload={canDownload}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  )
}

export default IndicatorCarousel
